<template>
  <div class="sidebar">
    <FsTooltip
      class="tooltip"
      placement="right"
      v-for="item in sidebarList"
      :key="item.name"
      :id="item.menuId"
      :content="item.label"
      :popper-content-style="{
        color: '#fff',
        lineHeight: '22px',
      }"
      text
    >
      <RouterLink :to="item.path" class="sidebar-item" :class="{ _active: route.path.includes(item.path) }">
        <span :class="item.iconfontClass" :id="item.menuId"></span>
      </RouterLink>
    </FsTooltip>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import { FsTooltip } from 'fs-design'

const route = useRoute()
const userStore = useUserStore()
const { customersType } = storeToRefs(userStore)
const sidebarList = ref([
  {
    name: '设计中心',
    path: '/design-center',
    iconfontClass: 'iconfont icon-tuobutu',
    label: 'Topology',
    menuId: 'DesignCenter',
  },
  {
    name: '产品清单',
    label: 'Product List',
    path: '/product-catalog',
    iconfontClass: 'iconfont icon-shebeiqingdan',
    menuId: 'ProductCatalog',
  },
  {
    name: '项目管理',
    label: 'Project Management',
    path: '/project',
    iconfontClass: 'iconfont icon-xiangmuguanli',
    menuId: 'ProjectManage',
  },
])

watch(
  () => customersType.value,
  newVal => {
    if (newVal === 'SUPER_ADMINISTRATOR') {
      // sidebarList.value.push({
      //   name: '模板管理',
      //   label: 'Template Management',
      //   path: '/template-manage',
      //   iconfontClass: 'iconfont icon-mobanguanli',
      //   menuId: 'TemplateManagement',
      // })
    }
  },
  {
    immediate: true,
  }
)
</script>

<style lang="scss" scoped>
.sidebar {
  width: 50px;
  height: 100%;
  background-color: #fff;
  border-right: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0;
  box-sizing: border-box;
  flex-shrink: 0;

  :deep(.fs-tooltip) {
    margin-bottom: 16px;
  }

  .sidebar-item {
    display: flex;
    width: 36px;
    height: 36px;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    color: #19191a;
    transition: all 0.3s;

    &:hover {
      background: rgba(25, 25, 26, 0.04);
    }

    &._active {
      color: #4080ff;
      background: rgba(25, 25, 26, 0.04);
    }

    .iconfont {
      display: inline-block;
      width: 20px;
      height: 20px;
      font-size: 20px;
    }
  }
}
</style>
